// client/src/routes/app/index.tsx — „/app" · UI-003 (04 §9.2: „→ redirect /app/dashboard").
//
// The redirect is thrown in `beforeLoad`, not rendered in a component: a component-level
// redirect mounts the shell, paints an empty page container and only then navigates, which is
// a visible flash on every visit to the bare `/app`.

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/')({
  beforeLoad: () => {
    throw redirect({ to: '/app/dashboard' });
  },
});
